<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            게시판 목록
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          </div>
          <grid
            ref="boardGrid"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :theme="gridProps.theme"
            :rowHeaders="gridProps.rowHeaders"
            :columnOptions="gridProps.columnOptions"
            :language="gridProps.lang"
            @dblclick="onDblClickExecutive"
            @response="response"
          ></grid>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="newBoard()">
            <md-icon>person_add</md-icon>
            등록
          </md-button>
        </md-card-actions>
      </md-card>
    </div>

    <!--사용자 입력/수정 팝업 -->
    <modal v-if="isShowBoardModal" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">게시판 등록(변경)</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="
            () => {
              this.isShowBoardModal = false;
            }
          "
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <!--
TODO: 공지사항 게시기간 사용시 주석 제거
            <tr>
              <th>게시기간</th>
              <td colspan="7">
                <div class="inline-flex">
                  <input type="text" v-model="boardData.boardStartDt" ref="boardStartDt" required v-mask-date-time maxlength="12" class="w110">
                  <span>~</span>
                  <input type="text" v-model="boardData.boardEndDt" ref="boardEndDt" required v-mask-date-time maxlength="12" class="w110">
                </div>
              </td>
            </tr>
-->
            <tr>
              <th star>제목</th>
              <td colspan="7">
                <input type="text" v-model="boardData.subject" />
              </td>
            </tr>
            <tr>
              <th star>내용</th>
              <td colspan="7">
                <!-- initialEditType="wysiwyg"   "markdown" -->
                <Editor
                  ref="toastuiEditor"
                  v-if="boardData.content != null"
                  initialEditType="wysiwyg"
                  previewStyle="tab"
                  height="400px"
                  minHeight="300px"
                  language="ko-KR"
                  useCommandShortcut="true"
                  useDefaultHTMLSanitizer="true"
                  usageStatistics="false"
                  hideModeSwitch="false"
                  placeholder="내용을 입력 하세요"
                  :initialValue="this.boardData.content"
                  @load="onEditorLoad"
                  @focus="onEditorFocus"
                  @blur="onEditorBlur"
                  @change="onEditorChange"
                  @stateChange="onEditorStateChange"
                />
              </td>
            </tr>

            <tr>
              <th>첨부파일</th>
              <td colspan="7">
                <div class="inline-flex">
                  <input
                    type="file"
                    class="hidden-input-file"
                    id="boardFileInput"
                  />
                  <input type="text" v-model="boardData.fileName" />
                  <span
                    type="button"
                    @click="onClickSearchFile"
                    style="cursor: pointer"
                  >
                    <md-icon>search</md-icon>
                  </span>
                  <input type="text" v-model="savedFileName" disabled />
                  <span
                    type="button"
                    @click="onClickDownLoad"
                    style="cursor: pointer;"
                    :disabled="savedFileName == null || savedFileName == ''"
                  >
                    <md-icon>download</md-icon>다운로드
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="footer">
        <md-button
          class="md-info md-sm"
          @click="saveBoard"
          :disabled="
            this.boardData.insertUserNo && this.userNo.toLowerCase() != boardData.insertUserNo
          "
          >저장</md-button
        >
        <md-button
          class="md-info md-sm"
          @click="deleteBoard"
          :disabled="
            !this.isEdit || this.userNo.toLowerCase() != boardData.insertUserNo
          "
          >삭제</md-button
        >
        <md-button
          class="md-default md-sm"
          @click="
            () => {
              this.isShowBoardModal = false;
              this.isEdit = false;
            }
          "
          >닫기</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Modal } from "@/components";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import { Grid } from "@toast-ui/vue-grid";
import "tui-grid/dist/tui-grid.css";
import "tui-pagination/dist/tui-pagination.css";
import "codemirror/lib/codemirror.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import { Editor } from "@toast-ui/vue-editor";
import moment from "moment";
import session from "@/kuaa/kuaa-sessions";

export default {
  components: {
    Modal,
    grid: Grid,
    Editor
  },
  created() {
    this.initGrid();
  },
  computed: {
    total: function() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      userNo: session.get("userNo"),
      isShowBoardModal: false,
      attchFile: null,
      savedImgUrl: "",
      savedFileBaseId: "",
      savedFileName: "",
      pagination: {
        page: 1,
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      boardData: {
        boardCtgCd: null,
        boardId: null,
        uprBoardId: null,
        subject: null,
        content: null,
        fileName: null,
        insertUserNo: null,
        insertDate: null,
        updateUserNo: null,
        updateDate: null,
        boardStartDt: null,
        boardEndDt: null
      }
    };
  },

  methods: {
    newBoard() {
      this.isEdit = false;
      this.savedFileName = null;
      this.attchFile = null;
      this.savedImgUrl = "";
      this.savedFileBaseId = "";
      this.boardData = {
        boardCtgCd: "PUB",
        boardId: null,
        uprBoardId: null,
        subject: null,
        content: "",
        fileName: null,
        boardStartDt: null,
        boardEndDt: null,
        insertUserNo: null
      };
      this.isShowBoardModal = true;
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(
        URL_CONST.GET_BOARD_LIST,
        true,
        this.pagination
      );
      this.gridProps["el"] = this.$refs.boardGrid;
      this.gridProps["columns"] = [
        { header: "게시판ID", name: "boardId", hidden: true },
        { header: "제목", name: "subject" },
        { header: "작성자", name: "insertUserNo", align: "center" },
        { header: "작성일시", name: "insertDate", align: "center" },
        { header: "변경자", name: "updateUserNo", align: "center" },
        { header: "변경일시", name: "updateDate", align: "center" },
        { header: "파일첨부", name: "isFileAttch", align: "center" },
        { header: "", name: "boardCtgCd", hidden: true },
        { header: "", name: "uprBoardId", hidden: true },
        { header: "", name: "readCnt", hidden: true },
        { header: "", name: "boardStartDt", hidden: true },
        { header: "", name: "boardEndDt", hidden: true }
      ];
    },
    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if (res.result) {
        this.pagination.total = res.data.pagination.totalCount;
      } else {
        kuaaFnc.showSwal("게시판 관리", res.resultMessage);
      }
    },

    doSearch() {
      this.$refs.boardGrid.invoke("readData", 1, {}, true);
    },

    onDblClickExecutive(e) {
      if (e.instance.getRow(e.rowKey) != null) {
        this.isEdit = true;
        this.isShowBoardModal = true;
        this.boardData = e.instance.getRow(e.rowKey);
        this.savedFileName = this.boardData.orgFileNm;
        this.savedImgUrl = this.boardData.file;
        this.savedFileBaseId = this.boardData.fileBaseId;
        this.boardData.fileName = null;
      }
    },
    onClickSearchFile(event) {
      let input = document.getElementById("boardFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.boardData.fileName = file.name;
        this.attchFile = file;
      };

      input.click();
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onClickDownLoad() {
      if (!this.savedFileName) return false;
      location.href =
        URL_CONST.FILE_DOWN_LOAD + "?fileBaseId=" + this.boardData.fileBaseId;
    },
    savePhoto(data) {
      if (this.boardData.fileName != null) {
        let formData = new FormData();
        formData.append("uploadFiles", this.attchFile);
        formData.append("fileCtgCd", "BOARD");
        formData.append("fileBizId", data.boardCtgCd + data.boardId);

        kuaaApi.sendServerMixData(
          URL_CONST.FILE_UPLOAD,
          formData,
          "post",
          res => {
            if (res.data.success) {
              if (res.data.data[0].fileBaseId) {
                this.savedImgUrl =
                  URL_CONST.FILE_DOWN_LOAD +
                  "?fileBaseId=" +
                  res.data.data[0].fileBaseId;
                this.savedFileBaseId = res.data.data[0].fileBaseId;
                kuaaFnc.showSwal("게시판 저장", "저장 되었습니다.");
                this.$refs.boardGrid.invoke("readData", 1, null);
              }
            } else {
            }
          }
        );
      }
    },

    saveBoard(e) {
      this.isShowBoardModal = false;
      let _this = this;
      let modalOptions = "";
      this.boardData.content = this.$refs.toastuiEditor.invoke("getMarkdown");

      if (!this.boardData.subject) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "제목을 입력해 주세요."
        });
        Swal.fire(modalOptions).then(() => (_this.isShowBoardModal = true));
        return false;
      }

      if (!this.boardData.content) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "내용을 입력해 주세요."
        });
        Swal.fire(modalOptions).then(() => (_this.isShowBoardModal = true));
        return false;
      }

      //TODO: 공지사항 게시기간 사용시
      //if(!this.checkBoardDt()) return false;

      let url = URL_CONST.SAVE_BOARD;
      if (this.isEdit) url = URL_CONST.UPDATE_BOARD;
      this.boardData.content = this.$refs.toastuiEditor.invoke("getMarkdown");
      this.isShowBoardModal = false;
      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "내용을 저장 하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(url, this.boardData, "post", response => {
            if (response.data.success) {
              if (this.boardData.file != "") {
                this.savePhoto(response.data.data);
              }
              this.doSearch();
            } else {
              kuaaFnc.showSwal("게시판 저장", response.data.resultMessage);
            }
          });
        } else {
          this.isShowBoardModal = true;
        }
      });
    },

    deleteBoard() {
      this.isShowBoardModal = false;
      Swal.fire(
        kuaaFnc.getSwalModaloptions("confirm", {
          html: "삭제 하시겠습니까?"
        })
      ).then(result => {
        if (result.value) {
          kuaaApi.sendServer(
            URL_CONST.DELETE_BOARD,
            this.boardData,
            "post",
            response => {
              if (response.data.success) {
                this.doSearch();
              } else {
                kuaaFnc.showSwal("게시판 삭제", response.data.resultMessage);
              }
            }
          );
        } else {
          this.isShowBoardModal = true;
        }
      });
    },

    scroll() {
      this.$refs.toastuiEditor.invoke("scrollTop", 10);
    },
    moveTop() {
      this.$refs.toastuiEditor.invoke("moveCursorToStart");
    },
    getHtml() {
      let html = this.$refs.toastuiEditor.invoke("getHtml");
    },

    onEditorLoad() {
      // implement your code
    },
    onEditorFocus() {
      // implement your code
    },
    onEditorBlur() {
      // implement your code
    },
    onEditorChange() {
      // implement your code
    },
    onEditorStateChange() {
      // implement your code
    },

    //TODO: 공지사항 게시기간 사용시
    checkBoardDt() {
      let from = this.boardData.boardStartDt
        ? this.boardData.boardStartDt.replace(/[^0-9]/g, "")
        : "";
      let to = this.boardData.boardEndDt
        ? this.boardData.boardEndDt.replace(/[^0-9]/g, "")
        : "";

      let modalOptions = null;
      if (!from) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "게시 시작일시는 필수입니다"
        });
        Swal.fire(modalOptions).then(() => (this.isShowBoardModal = true));
        return false;
      } else {
        if (!moment(from, "YYYYMMDDHHmm", true).isValid()) {
          modalOptions = kuaaFnc.getSwalModaloptions({
            html:
              "게시 시작일시를 정확히 입력해 주세요<br>예)202101010900(2021년 1월 1일 18:00)"
          });
          Swal.fire(modalOptions).then(() => (this.isShowBoardModal = true));
          return false;
        }
      }

      if (!to) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "게시 종료일시는 필수입니다."
        });
        Swal.fire(modalOptions).then(() => (this.isShowBoardModal = true));
        return false;
      } else {
        if (!moment(to, "YYYYMMDDHHmm", true).isValid()) {
          modalOptions = kuaaFnc.getSwalModaloptions({
            html:
              "게시 종료일시를 정확히 입력해 주세요.<br>예)202103311800(2021년 3월 31일 18:00)"
          });
          Swal.fire(modalOptions).then(() => (this.isShowBoardModal = true));
          return false;
        }
      }

      if (from > to) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "게시 기간을 다시 확인해 주세요"
        });
        Swal.fire(modalOptions).then(() => (this.isShowBoardModal = true));
        return false;
      }
      this.boardData.boardStartDt = from;
      this.boardData.boardEndDt = to;
      return true;
    }
  }
};
</script>

<style scoped>
tr.md-table-row {
  cursor: pointer;
}
</style>
